import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import {
  changeFieldDefinitionProp,
  changeLayoutElementProp,
  clearFormEdited,
  deleteElement,
  formDefinitionLayoutChanged,
  formDefinitionOptionsChanged,
  formDefinitionSchemaChanged,
  insertElement,
  onMoveElement,
  renameColumnElement,
  renameFieldElement,
} from "developer/edit/store/editorSlice";
import { saveFormDefinition } from "store/form/formDataSlice";

type ConfirmationStatus = "confirmationRequested" | "closeConfirmed";

type InitialState = {
  isDirty: boolean;
  closeConfirmationStatus?: ConfirmationStatus;
};

const initialState: InitialState = {
  isDirty: false,
};

export const closeConfirmationStatusSlice = createSlice({
  name: "confirmationStatus",
  initialState,
  reducers: {
    setCloseConfirmationStatus: (
      state,
      action: PayloadAction<{
        isDirty?: boolean;
        closeConfirmationStatus?: ConfirmationStatus;
      }>
    ): void => {
      const { isDirty, closeConfirmationStatus } = action.payload;
      if (typeof isDirty === "boolean") {
        state.isDirty = isDirty;
      }
      state.closeConfirmationStatus = closeConfirmationStatus;
    },
    resetConfirmationStatus: () => initialState,
  },
  extraReducers: (builder) =>
    builder
      .addCase(formDefinitionSchemaChanged.type, (state) => {
        state.isDirty = true;
      })
      .addCase(formDefinitionLayoutChanged.type, (state) => {
        state.isDirty = true;
      })
      .addCase(formDefinitionOptionsChanged.type, (state) => {
        state.isDirty = true;
      })
      .addCase(changeLayoutElementProp.type, (state) => {
        state.isDirty = true;
      })
      .addCase(changeFieldDefinitionProp.type, (state) => {
        state.isDirty = true;
      })
      .addCase(renameFieldElement.type, (state) => {
        state.isDirty = true;
      })
      .addCase(renameColumnElement.type, (state) => {
        state.isDirty = true;
      })
      .addCase(insertElement.type, (state) => {
        state.isDirty = true;
      })
      .addCase(onMoveElement.type, (state) => {
        state.isDirty = true;
      })
      .addCase(deleteElement.type, (state) => {
        state.isDirty = true;
      })
      .addCase(saveFormDefinition.fulfilled, (state) => {
        state.isDirty = false;
      })
      .addCase(clearFormEdited.type, (state) => {
        state.isDirty = false;
      }),
});

export const { setCloseConfirmationStatus, resetConfirmationStatus } =
  closeConfirmationStatusSlice.actions;
